<template>
  <div>
    <h2>外国人の犯罪件数(検挙率)</h2>
    <div class="px-4 py-8">
      <multiselect
        v-model="display_country_keys"
        :options="display_options"
        :multiple="true"
        group-values="countries"
        group-label="region"
        placeholder="国を選択"
        label="country_key"
        track-by="country_key"
      />
    </div>
    <LineChart
      :x_labels="display_country_x_labels"
      :data="display_country_datasets"
      :hanrei_labels=display_country_hanrei
      class="py-6"
    />
    <div>
      <p>参考</p>
      <a href="https://www.npa.go.jp/publications/statistics/sousa/statistics.html">警察庁HP > 犯罪統計</a>
    </div>
  </div>

  <!-- エラーのトースト -->
  <v-snackbar 
    v-model="toast_flag" timeout="1000"
    style="align-items: center; text-align-last: center;"
    color="red-accent-1"
  >
    {{ toast_msg }}
  </v-snackbar>
</template>
  
  <script>
import { ref, onMounted, computed } from "vue";
import { ALL_COUNTROY_DICT } from '@/javascripts/country_key.js'
import LineChart from '@/components/Graph/LineChart.vue'
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'

export default {
  name: 'crime_statistics',
  components: { LineChart, Multiselect },
  setup() {
    // #####
    // LCM #
    // #####
    onMounted ( async () => {
      const res_json = await request_db({})
      all_countory_data.value = JSON.parse(res_json["statistics"]);
    }) 
    
    // ########
    // データ #
    // ########
    const all_countory_data = ref()
    const error_ret = ref()
    
    // ########
    // DB接続 #
    // ########
    const request_db = async (body) => {
      show_toast("データを取得中...")
      const body_json = JSON.stringify(body)
      try {
        // 通信
        const res = await fetch('https://k5ljagmpel.execute-api.ap-northeast-1.amazonaws.com/crime_statistics', {
          method: 'POST',  // APIがPOSTを期待していれば
          headers: {
            'Content-Type': 'application/json'
          },
          body: body_json,
        });

        if (!res.ok) {
          throw new Error(`HTTP error! status: ${res.status}`);
        }

        const json = await res.json();
        return json;

      } catch (err) {
        error_ret.value = err
      }
    };
    
    // ########### #####
    // グラフ表示データ #
    // ########### #####
    const display_options = computed(() => {
      const options = []
      for (const region_key in ALL_COUNTROY_DICT) {
        const countries = ALL_COUNTROY_DICT[region_key]
        options.push({
          region: region_key,
          countries: countries.map(
            (country) => ({ region_key: region_key, country_key: country })
        )
        })
      }
      return options
    })
    
    // ########### #####
    // グラフ表示データ #
    // ########### #####
    const display_country_keys = ref([{ region_key: "全世界", country_key: "総数" }]); // 初期値としてアジアの最初の国を設定})
    const display_country_data = computed(() => {
      if (!all_countory_data.value) {
        return []
      }
      const ret_list = []
      for (const index_key in display_country_keys.value) {
        const display_country_key = display_country_keys.value[index_key]
        const temp_ret_list = []
        for (const index_year in all_countory_data.value) {
          const yaer_data = all_countory_data.value[index_year]
          for (const index_country in yaer_data) {
            const country_data = yaer_data[index_country]
            const tmp_country_name = country_data["country"]
            const tmp_region_name = country_data["region"]

            // 表示データの制御
            const is_target_country = tmp_country_name === display_country_key["country_key"]
            const is_target_region = tmp_region_name === display_country_key["region_key"]
            if (is_target_country && is_target_region) {
              temp_ret_list.push(country_data)
            }
          }
        }
        ret_list.push(temp_ret_list)
      }
      return ret_list
    })

    const display_country_datasets = computed(() => {
      if (!display_country_data.value) {
        return []
      }
      const ret_list = []
      for (const index in display_country_data.value) {
        const temp_countory = display_country_data.value[index]
        const temp_countory_dataset = temp_countory.map(row => row.total)
        ret_list.push(temp_countory_dataset)
      }
      return ret_list
    })
    
    const display_country_x_labels = computed(() => {
      if (!display_country_data.value) {
        return []
      }
      if (display_country_data.value.length < 1) {
        return []
      }
      return display_country_data.value[0].map(row => row.year)
    })
    
    const display_country_hanrei = computed(() => {
      if (!display_country_data.value) {
        return []
      }
      const ret_list = []
      for (const index in display_country_keys.value) {
        const temp_country_key = display_country_keys.value[index]
        const label = temp_country_key["region_key"] + " > " + temp_country_key["country_key"]
        ret_list.push(label)
      }
      return ret_list
    })

    // #################
    // トースト #
    // #################
    const toast_flag = ref(false)
    const toast_msg = ref("")
    const show_toast = (msg) => {
      toast_msg.value = msg
      toast_flag.value = true
    }


    return {
      // データ
      error_ret,
      all_countory_data,
      // keys
      ALL_COUNTROY_DICT,
      // 表示データ
      display_country_keys,
      display_country_data,
      display_country_datasets,
      display_country_x_labels,
      display_country_hanrei,
      display_options,
      // トースト
      toast_flag,
      toast_msg,
      show_toast,
    }
  }
}
</script>
  